var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOuvrage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 30 28",
    fill: "#57454A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3335 0.666626C12.3335 2.87996 10.5468 4.66663 8.3335 4.66663C7.60016 4.66663 7.00016 5.26663 7.00016 5.99996H4.3335C4.3335 3.78663 6.12016 1.99996 8.3335 1.99996C9.06683 1.99996 9.66683 1.39996 9.66683 0.666626H12.3335ZM15.0002 3.33329L7.00016 9.43996V7.33329H4.3335V11.48L0.333496 14.5333L1.94683 16.6533L4.3335 14.8266V27.3333H25.6668V14.8266L28.0535 16.64L29.6668 14.5333L15.0002 3.33329ZM17.5868 8.66663H12.4002L15.0002 6.69329L17.5868 8.66663ZM8.92016 11.3333H21.0802L23.0002 12.8V14H7.00016V12.8L8.92016 11.3333ZM23.0002 16.6666V19.3333H7.00016V16.6666H23.0002ZM7.00016 24.6666V22H23.0002V24.6666H7.00016Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOuvrage);
export default __webpack_public_path__ + "static/media/ouvrage.d989bb69ea118af97fbfa16e51e99a16.svg";
export { ForwardRef as ReactComponent };